export default __webpack_public_path__ + "static/media/528.8fe64901.png";